import { useEffect } from 'react'

import { useFetchProfileQuery } from 'features/SettingsOld/state/api/settingsApi'

import { getEmrPinConfig } from './emr-pins'
import { clearIntakeLock } from './intake-lock'
import { PinPromptModal } from './pin-prompt-modal'
import { useBlockPageExit } from './use-block-page-exit'

// Above every overlay (e.g. the auto-opening patient info dialog).
const INTAKE_GATE_Z_INDEX = 100000

// isIntakeBlocking is owned by the intake dialog; this gate must not set it (would loop IntakeLockGate).
export const IntakeReleaseGate = () => {
  const { data: profile, isLoading } = useFetchProfileQuery(null)
  const { pins, pinLength } = getEmrPinConfig(profile?.profile)

  useBlockPageExit(true)

  // No staff PIN configured: release automatically once the profile resolves.
  useEffect(() => {
    if (!isLoading && pins.length === 0) {
      clearIntakeLock()
    }
  }, [isLoading, pins.length])

  return (
    <PinPromptModal
      isVisible
      emrPins={pins}
      pinLength={pinLength}
      dismissible={false}
      loading={isLoading}
      zIndex={INTAKE_GATE_Z_INDEX}
      onVerified={clearIntakeLock}
    />
  )
}
